import {gql} from "@apollo/client";
import {OrderDetailType} from "../../../../../graphql/types/OrderDetailType";

export const GET_ORDER_DETAIL_FOR_DELIVERY = gql`
    query DeliveryQuery($orderId: Long!) {
        getOrderDetailForDelivery(orderId: $orderId) {
            orderId
            orderWithAddresses{
                order{
                    id
                    securityRnd
                    trackingNumber
                    channelId
                    channelOrderNumber
                    orderTime
                    overallStatus
                    isDelivered
                    isIntercepted
                    isAbnormal
                    exceptionStatus
                    warehouseLocationCode
                    storageNumber
                    expectedDeliveryTime
                    deliveredAt
                    deliveryAttempts
                    exceptionReasonCode
                    exceptionSubReasons
                    senderAddressId
                    recipientAddressId
                    receiverZipcode
                    sortingCode
                    zone
                    newZone
                    weightKg
                    volumetricWeightKg
                    lengthCm
                    widthCm
                    heightCm
                    packageValueUsd
                    originalWeightKg
                    originalLengthCm
                    originalWidthCm
                    originalHeightCm
                    podReviewStatus
                    podReviewMessage {
                        id
                        failureOtherReason
                        lang
                        translateFailureOtherReason {
                            lang
                            translateFailureOtherReason
                        }
                    }
                    podImageS3KeysJson
                    exceptionImageS3KeysJson
                    isReceiverAddressModified
                    isDestHubArrived
                    isDestWarehouseArrived
                    destHubArrivedAt
                    destWarehouseArrivedAt
                    receivedAtHub
                    deliverAt
                    isComplaint
                    hasManded
                    isFinished
                    podImageS3UrlsJson
                    exceptionImageS3UrlsJson
                    nextAction
                    isHasBeenSetException
                    lastBagTaskId
                    bagTaskNumber
                }
                pickupAddress{
                    id
                    addressLine1
                    addressLine2
                    city
                    state
                    zipcode
                    fullName
                    phoneNumber
                    countryCode
                    extension
                    email
                    company
                    latitude
                    longitude
                    instructions
                }
                deliveryAddress{
                    id
                    addressLine1
                    addressLine2
                    city
                    state
                    zipcode
                    fullName
                    phoneNumber
                    countryCode
                    extension
                    email
                    company
                    latitude
                    longitude
                    instructions
                }
                returnAddress {
                    id
                    channelId
                    channelOrderNumber
                    externalTrackingNumber
                    trackingNumber
                    addressType
                    addressLine1
                    addressLine2
                    district
                    city
                    stateProvince
                    postalCode
                    countryCode
                    fullName
                    phoneNumber
                    email
                }
                originalRecipientAddress {
                    id
                    channelId
                    channelOrderNumber
                    externalTrackingNumber
                    trackingNumber
                    addressType
                    addressLine1
                    addressLine2
                    district
                    city
                    stateProvince
                    postalCode
                    countryCode
                    fullName
                    phoneNumber
                    email
                }
            }
            orderNote {
                note
                lang
                orderNoteTranslations {
                    translateNote
                    lang
                }
            }
            driverDeliveryNote {
                note
                lang
                orderNoteTranslations {
                    translateNote
                    lang
                }
            }
            externalOrderEvents {
                eventCode
                eventTime
                localGmtOffset
                description
                location
                reasonCode
                operatorAccountName
                sourceOrderEventId
            }
            orderEvents{
                eventId
                time
                type
                title
                details
                imageS3UrlsJson
                cameraPhotos {
                    s3Key
                    cameraType
                    reviewResults
                }
                nextAction
                exceptionReasonCode
                exceptionSubReasons
                channelId
                channelApiVersion
                phoneNumber
                failReason
                podComment
                previousStatus
                previousReviewNotes
                newStatus
                operationSource
                appointmentNumber
                driverAccountId
                driverName
                driverPhone
                dspId
                dspName
                operatorName
                operatorPhone
                operatorRole
                operatorWarehouseName
                operatorDspName
                pickupHubName
                sortingMachineCode
                sortingMachineType
                currentWarehouseName
                bagNumber
                clientCartonNo
                presortCode
                bagSortingCode
                scanSource
                loadRemoveType
                originalScanAction
                bagTaskName
                fromBagNumber
                toBagNumber
                reason
                oldSortingRule
                newSortingRule
                licensePlate
                sealNo
                deliveryAttempts
                deliveryDistance
                deliveryMethod
                latitude
                longitude
                weightKg
                originalEventType
                isDestHubArrived
                scStages
                externalBusinessType
                bagContainerId
                bagContainerName
                fromBagChange
                isFirstLmArrival
                operatePlatformType
                messageKey
                notes
                departureEventType
                carrierName
                revokeReason
                oldRecipientAddress {
                   id
                   fullName
                   addressLine1
                   addressLine2
                   city
                   state
                   zipcode
                   phoneNumber
                   email
                   countryCode
                   extension
                   company
                   instructions
                }
                newRecipientAddress {
                   id
                   fullName
                   addressLine1
                   addressLine2
                   city
                   state
                   zipcode
                   phoneNumber
                   email
                   countryCode
                   extension
                   company
                   instructions
                }
                oldFullName
                oldPhoneCountryCode
                oldPhoneNumber
                oldPhoneExtension
                newFullName
                newPhoneCountryCode
                newPhoneNumber
                newPhoneExtension
                oldOrderNote{
                    note
                    lang
                    orderNoteTranslations {
                        translateNote
                        lang
                    }
                }
                newOrderNote{
                    note
                    lang
                    orderNoteTranslations {
                        translateNote
                        lang
                    }
                }
                driverDeliveryNote{
                    note
                    lang
                    orderNoteTranslations {
                        translateNote
                        lang
                    }
                }
                oldLengthCm
                oldWidthCm
                oldHeightCm
                newLengthCm
                newWidthCm
                newHeightCm
                oldLatitude
                oldLongitude
                newLatitude
                newLongitude
                addressLocationReviewStatus
            }
            deliveryInfo {
                stopNumber
                subStopNumber
                driverAccountId
                driverName
                driverPhone
                taskDate
                routeName
                deliveryLatitude
                deliveryLongitude
                deliveryDistance
                lastScannedDriverAccountId
                lastScannedDriverName
                lastAssignedDriverAccountId
                lastAssignedDriverName
            }
            orderWms {
                ttSortingCode
                sortingRule
                ttBizType
                sortingSegmentCode
                lastMileSortingCode
            }
            deliveryRevokeStatus {
                canRevoke
                revokeDeadline
            }
            canEditAddressLocation
            addressLocationChangePending
            pendingLatitude
            pendingLongitude
        }
    }
`;

export interface DeliveryOrderDetailResponse {
    getOrderDetailForDelivery: OrderDetailType;
}
